<template>
    <script type="text/x-template" id="template-ai-colour-extract" class="template">
        <li class="block edit_block ai-colour-extract-block adjustment-block preview-based">
            <div class="header-container edit_block_header drag_handle">
                <label class="lookup_block_name name">AI Colour Extract (Legacy)</label>
            </div>

            <div class="block_options">
                <div class="block-sliders-container">
                    <span class="slider-name">White balance</span>
                    <input type="range" min="-4000" max="4000" value="0" step="1" data-pass-index="0"
                           class="range_slider white_balance_slider adjustmentBlock-slider"
                    >
                    <div class="input-group --with-knob">
                        <input type="text" class="input-knob"/>
                        <input type="number" class="range_value white_balance_range adjustmentBlock-range" value="0"
                               name="quantity" min="-4000" max="4000" step="1"
                        >
                    </div>
                </div>

                <div class="block-sliders-container">
                    <span class="slider-name">Tint</span>
                    <input type="range" min="-100" max="100" value="0" step="1" data-pass-index="1"
                           class="range_slider tint_slider adjustmentBlock-slider"
                    >
                    <div class="input-group --with-knob">
                        <input type="text" class="input-knob"/>
                        <input type="number" class="range_value tint_range adjustmentBlock-range" value="0"
                               name="quantity" min="-100" max="100" step="1"
                        >
                    </div>
                </div>

                <div class="sample-selector">
                    <span class="block-control-btn select-asset-btn">
                        <i class="material-icons">add</i>
                        Select Match...
                    </span>
                    <span class="name"></span>
                </div>

                <div class="lut-selector mb-3">
                    <div class="lut-selector__label-container disabled">
                        <span class="selected-lut-name">Select Look...</span>
                        <i class="material-icons">expand_more</i>
                    </div>
                    <div class="lut-selector__items-container"></div>
                </div>

                <div class="block-sliders-container">
                    <span class="slider-name">Opacity</span>
                    <input type="range" min="0" max="100" value="100" data-default-value="100"
                           class="range_slider opacity_slider"
                    >
                    <input type="number" class="lookup_range_value range_value opacity-input" value="100" min="1"
                           max="100"
                    >
                </div>
            </div>
        </li>
    </script>
</template>
<script>

export default {};
</script>

<style></style>
